// extracted by mini-css-extract-plugin
module.exports = {"pill":"pill-37RRc","pill-span":"pill-span-29Ebp","pillSpan":"pill-span-29Ebp","pill-tag":"pill-tag-1wXm3","pillTag":"pill-tag-1wXm3"};